import React, { useEffect, useState } from "react";
import InputField from "../../common_component/component/InputField";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  ADD_ICON,
  COPY_ICON,
  EDIT_ICON,
  VIEW_ICON,
} from "../../cufront-assets/icons/Icons";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";
import { getImageURL } from "../../_helper/utils/image";
import NameAvatar from "../../all-patient/components/NameAvatar";

const UserTable = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const groupId = searchParams.get("group_id");
  const optionId = searchParams.get("option_id");
  const mode = searchParams.get("mode");
  const [userData, setUserData] = useState();
  const [clinic] = useAtom(clinicAtom);
  const [filteredData, setFilteredData] = useState([]);
  const [searchInput, setSearchInput] = useState();

  const query = `?action=getClinicStaff&backend=True&clinic_id=${clinic?.id}`;

  const { data, isLoading } = useItemsFilter(
    ApiEndPoint?.CLINIC,
    query,
    clinic?.id ? true : false
  );

  useEffect(() => {
    if (data) {
      setUserData(data);
      setFilteredData(data);

      //(userData, "userData");
    }
  }, [data]);

  const handleEdit = (id) => {
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=edit&id=${id}`
    );
  };

  const handleView = (id) => {
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=view&id=${id}`
    );
  };

  const handleSearch = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);
    const filtered = userData.filter((user) => {
      return (
        user?.doctor_personal_details?.first_name
          ?.toLowerCase()
          .includes(inputValue.toLowerCase()) ||
        user?.doctor_personal_details?.first_name
          ?.toLowerCase()
          .includes(inputValue.toLowerCase())
      );
    });
    setFilteredData(filtered);
  };

  const handleCreateClick = () => {
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=create`
    );
  };

  return (
    !mode && (
      <>
        <div className="gap-[25px] large:gap-[35px]">
          <div className="cu-setup-table-container">
            <div className="cu-setup-table-search">
              <div
                className="cu-setup-table-create-icon"
                onClick={handleCreateClick}
              >
                <span>
                  <img src={ADD_ICON} alt="add icon" />
                </span>
                <span>Create</span>
              </div>
              <div className="cu-setup-table-search-input">
                <InputField
                  type="text"
                  placeholder="Search"
                  value={searchInput}
                  search={true}
                  onChange={(e) => handleSearch(e)}
                  loading={isLoading}
                />
              </div>
            </div>
            <div className="cu-setup-table">
              <table>
                <thead className="cu-setup-table-header">
                  <tr>
                    {/* <th>Employee ID</th> */}
                    <th>Name</th>
                    <th>Mobile Number</th>
                    <th>Email</th>
                    {/* <th>Date of Birth</th>
                    <th>Gender</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData?.map((trow, i) => {
                    return (
                      <tr key={i}>
                        {/* <td>
                          {trow?.doctor_personal_details?.employee_number}
                        </td> */}
                        <td
                          onClick={() => handleView(trow?.id)}
                          className="text-[#17A1FA] cursor-pointer"
                        >
                          {trow?.doctor_personal_details?.first_name +
                            " " +
                            trow?.doctor_personal_details?.last_name}
                        </td>
                        <td>
                          {trow?.doctor_personal_details?.phone_number ||
                            "Not available"}
                        </td>
                        <td>
                          {trow?.doctor_personal_details?.email ||
                            "Not available"}
                        </td>
                        {/* <td>
                          {trow?.doctor_personal_details?.dob ||
                            "Not available"}
                        </td>
                        <td>
                          {trow?.doctor_personal_details?.gender ||
                            "Not available"}
                        </td> */}

                        <td>
                          <div className="cu-setup-table-action-col">
                            <img
                              src={EDIT_ICON}
                              alt="edit"
                              width={"15px"}
                              height={"15px"}
                              onClick={() => handleEdit(trow?.id)}
                            />
                            <img
                              src={VIEW_ICON}
                              alt="view"
                              width={"20px"}
                              height={"15px"}
                              onClick={() => handleView(trow?.id)}
                            />
                            {/* <img
                              src={COPY_ICON}
                              alt="copy"
                              width={"11.79px"}
                              height={"15px"}
                            /> */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {isLoading && <CuScreenLoader />}
      </>
    )
  );
};

export default UserTable;
